// Modules
import React from "react";
import PropTypes from "prop-types";

const Instagram = (props) => {
	const {
		clssName,
		color,
	} = props;

	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 30 30"
			xmlns="http://www.w3.org/2000/svg"
			className={clssName}
		>
			<path
				d="M29.9237 8.82035C29.8532 7.22642 29.5954 6.13033 29.2261 5.18102C28.845 4.17299 28.259 3.27065 27.4909 2.52035C26.7405 1.75832 25.8321 1.16654 24.8356 0.791389C23.8808 0.422113 22.7904 0.164384 21.1961 0.0939335C19.5895 0.0176125 19.0799 0 15.0059 0C10.9319 0 10.4222 0.0176125 8.82208 0.0880626C7.22783 0.158513 6.13153 0.416243 5.18203 0.785519C4.17322 1.16595 3.2707 1.75245 2.52026 2.51977C1.75866 3.27006 1.16676 4.17886 0.791544 5.17515C0.422196 6.13033 0.164416 7.21996 0.0939519 8.81389C0.017616 10.4202 0 10.9297 0 15.0029C0 19.0761 0.017616 19.5857 0.0880799 21.1855C0.158544 22.7795 0.416324 23.8755 0.785672 24.8249C1.16676 25.8329 1.75866 26.7352 2.52085 27.4855C3.27129 28.2476 4.17968 28.8393 5.17616 29.2145C6.13153 29.5838 7.22196 29.8415 8.81621 29.9119C10.4163 29.9824 10.9266 30 15 30C19.0734 30 19.5837 29.9824 21.1838 29.9119C22.778 29.8415 23.8743 29.5838 24.8238 29.2145C26.8403 28.4348 28.4345 26.8409 29.2143 24.8249C29.5837 23.8697 29.8415 22.7795 29.9119 21.1855C29.9824 19.5857 30 19.0755 30 15.0029C30 10.9303 29.9941 10.4202 29.9237 8.82035ZM27.222 21.0687C27.1574 22.534 26.9113 23.3249 26.7058 23.8526C26.2014 25.1595 25.1644 26.1969 23.8567 26.7012C23.3294 26.9061 22.532 27.1526 21.0722 27.2166C19.4897 27.2871 19.0147 27.3047 15.0112 27.3047C11.0076 27.3047 10.5267 27.2871 8.95009 27.2166C7.48444 27.1521 6.69348 26.9061 6.16559 26.7012C5.51497 26.4611 4.92308 26.08 4.44216 25.5816C3.94363 25.0949 3.56312 24.509 3.32237 23.8585C3.11744 23.3313 2.87082 22.534 2.80681 21.0746C2.73635 19.4924 2.71873 19.0174 2.71873 15.0147C2.71873 11.0119 2.73635 10.5311 2.80681 8.95479C2.8714 7.48943 3.11744 6.69863 3.32237 6.17084C3.56254 5.52035 3.94363 4.92857 4.44803 4.44775C4.93423 3.94932 5.52026 3.56888 6.17146 3.32877C6.69877 3.12387 7.49618 2.8773 8.95596 2.81272C10.5385 2.74227 11.0135 2.72466 15.017 2.72466C19.0264 2.72466 19.5015 2.74227 21.0781 2.81272C22.5437 2.8773 23.3347 3.12329 23.8626 3.32877C24.5132 3.56888 25.1051 3.9499 25.586 4.44775C26.0846 4.93444 26.4651 5.52035 26.7058 6.17084C26.9107 6.69804 27.1574 7.4953 27.222 8.95479C27.2924 10.537 27.31 11.0119 27.31 15.0147C27.31 19.0174 27.2918 19.4865 27.222 21.0687Z"
				fill={color}
			/>
			<path
				d="M15.0059 7.29639C10.7505 7.29639 7.29773 10.7479 7.29773 15.003C7.29773 19.2582 10.7505 22.7097 15.0059 22.7097C19.2613 22.7097 22.7141 19.2582 22.7141 15.003C22.7141 10.7479 19.2613 7.29639 15.0059 7.29639ZM15.0059 20.0021C12.2455 20.0021 10.0059 17.7635 10.0059 15.003C10.0059 12.2426 12.2455 10.004 15.0059 10.004C17.7669 10.004 20.0059 12.2426 20.0059 15.003C20.0059 17.7635 17.7669 20.0021 15.0059 20.0021Z"
				fill={color}
			/>
		</svg>
	);
};

Instagram.propTypes = {
	clssName: PropTypes.string,
	color: PropTypes.string,
};

Instagram.defaultProps = {
	clssName: "",
	color: "#EEDFD2",
};

export default Instagram;
